import { useQuery } from '@tanstack/vue-query';
import { environmentQueries } from '@services/overig/queries/EnvironmentQueries';
import { computed, type ComputedRef } from 'vue';

type Toggle =
  | 'MaatwerkdossierToggle'
  | 'MaatwerkTermijnToggle'
  | 'BerekenenFilterMaatschappijToggle'
  | 'TakensysteemWeergaveToggle'
  | 'PortefeuilleDashboardToggle'
  | 'NieuweGradatieTekstenToggle'
  | 'HoedanighedenMaatschappijcodesFrontendToggle'
  | 'WagenparkMutatieToggle'
  | 'WagenparkClausulesVoorwaardenOpsplitsenToggle'
  | 'ToonRichTextEditorInAanvraagdossierToggle'
  | 'RecenteActiviteitenCountersToggle'
  | 'SchadeTerugvalBerekenenToggle'
  | 'RelatiesUitgebreidZoekenViaManagementToggle'
  | 'OpenClausulesFeatureToggle';

export function useFeatureToggle(toggle: Toggle): ComputedRef<boolean | undefined> {
  const env = useQuery({
    ...environmentQueries.get(),
    select: (res) => res.data.featureFlags,
    staleTime: 60 * 1000,
    retry: 10,
  });
  return computed(() => env.data?.value?.[toggle]);
}
